"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lodash = require("lodash");
var _constants = require("./constants");
function isPendingReferral(referral) {
  return (0, _lodash.get)(referral, 'status') === _constants.REFERRAL_STATUS_PENDING;
}
var _default = exports["default"] = isPendingReferral;